// removed by extract-text-webpack-plugin
module.exports = {"select-pills":"select-pills__iqAh5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SelectPills/styles/main.scss
// module id = 2151
// module chunks = 1